export default __webpack_public_path__ + "static/media/onboarding2.edf00b4b.png";